/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Типы доставки
   */
  app.DeliveryTypes = app.Collection.extend({

    model: app.DeliveryType,

    urlRoot: app.entryScriptName + '/api/v4/delivery-type',

    expand: 'expand=pickup_point,delivery_times,paymentTypes,shipment_types',

    paymentDate: '',

    paymentTime: '',

    /** @inheritDoc */
    run: function () {
      app.Collection.prototype.run.apply(this);
    },
    /** @inheritDoc */
    parse: function (response) {
      this.paymentDates = response._payment_dates;
      this.paymentTime = response._payment_time;
      this.deliveryText = response.delivery_lifter_notice;
      return response.items;
    },
  });

})();

}.call(window));